import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { getLatestProjectStatus } from '../../../services/projects';
import * as actions from '../projectActions';
import { errorOpenModal } from '../../_shared/modal/errorModalActions';

export default function* fetchLatestProjectStatusWatcher() {
  yield takeLatest(actions.FETCH_LATEST_STATUS, fetchLatestProjectStatusWorker);
}

export function* fetchLatestProjectStatusWorker(action) {
  yield put(actions.statusLoading(true));

  try {
    const response = yield call(getLatestProjectStatus, action.closing_id);
    const data = _.get(response, 'data.latestProjectStatus', null);
    yield call(success, data);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(data) {
  yield put(actions.setLatestStatus(data));
  yield put(actions.statusLoading(false));
}

export function* failure(error) {
  yield put(actions.statusLoading(false));
  yield put(actions.statusError(error));
  yield put(
    errorOpenModal({
      title: 'Latest status could not be fetched',
      message: error.message,
    }),
  );
}
